// postcss-rtlcss-ignore.ts
import postcss from 'postcss';

// 设置正则匹配, 支持 * 通配符
const matchSelector = (originSelector: string, configSelector: string) => {
  if (!originSelector || !configSelector) return false;
  try {
    const regex = new RegExp(`${configSelector.replace('*', '.*')}$`);
    return regex.test(originSelector);
  } catch (error) {
    return false;
  }
};

export default function (opts = {}) {
  const { selectors = [], selectorMapProperties = {} } = opts as { selectors?: string[], selectorMapProperties?: Record<string, string[]> };

  return (root: postcss.Root) => {
    // 遍历所有的规则
    root.walkRules((rule: postcss.Rule) => {
      // 遍历规则中的选择器
      rule.selectors.forEach((selector: string) => {
        // 判断选择器是否匹配
        if (selectors.length > 0) {
          selectors.forEach((sel) => {
            if (matchSelector(selector, sel)) {
              // 在规则前添加注释
              rule.prepend(postcss.comment({ text: 'rtl:begin:ignore' }));
              // 在规则后添加注释
              rule.append(postcss.comment({ text: 'rtl:end:ignore' }));
            }
          });
        }
        // 如果选择器匹配 selectorMapProperties 中的任何一个
        Object.keys(selectorMapProperties).forEach((sel) => {
          if (matchSelector(selector, sel)) {
            const properties = selectorMapProperties[sel];
            // 遍历当前规则中的声明
            rule.walkDecls((decl) => {
              // 如果声明的属性匹配属性列表中的任何属性
              if (properties.includes(decl.prop)) {
                // 在该声明前后添加注释
                decl.before(postcss.comment({ text: 'rtl:begin:ignore' }));
                decl.after(postcss.comment({ text: 'rtl:end:ignore' }));
              }
            });
          }
        });
      });
    });
  };
}
